import React, { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import {
  selectHasMoreItems,
  selectLoading,
  selectPatientRegionsList,
  selectSortConfig,
} from "store/PatientRegionsStore/selectors";
import {
  changeSortOfPatientRegionsList,
  loadMorePatientRegions,
} from "store/PatientRegionsStore/actions";
import {
  selectCurrentClinician,
  selectCurrentClinicianLoading,
} from "store/ClinicianStore/selectors";
import { USER_GROUPS } from "constants/roles";
import { PatientRegion } from "types/PatientRegion";
import { selectSportFilterCategories } from "store/PatientStore/selectors";
import { ContainerForCoaches } from "./ContainerForCoaches";
import { ContainerForClinicians } from "./ContainerForClinicians";
import { CircularProgress } from "@mui/material";
import * as patientRegionsSlice from "store/PatientRegionsStore/patientRegionsSlice";

export const UserListContaier = ({
  setSelectedTab,
  selectedTab,
}: {
  setSelectedTab: any;
  selectedTab: any;
}) => {
  const dispatch = useAppDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const patientRegions = useAppSelector(selectPatientRegionsList);
  const currentClinician: any = useAppSelector(selectCurrentClinician);
  const currentClinicianLoading: any = useAppSelector(
    selectCurrentClinicianLoading
  );
  const hasMoreItems = useAppSelector(selectHasMoreItems);
  const sortConfig = useAppSelector(selectSortConfig);
  const loading = useAppSelector(selectLoading);
  const filterBySportsCategory = useAppSelector(selectSportFilterCategories);
  const [patientRegionsState, setPatientRegionsState] = useState<
    PatientRegion[]
  >([]);
  const patientsLimit = useAppSelector(
    ({ patientRegions }) => patientRegions.limit
  );

  const patientsTotal = useAppSelector(
    ({ patientRegions }) => patientRegions.total
  );

  useEffect(() => {
    setPatientRegionsState(patientRegions);
    if (filterBySportsCategory && filterBySportsCategory.length > 0) {
      let filteredBySportCategoryRegions = patientRegions
        .slice()
        .filter((e) => {
          return e.patient?.profileInfo?.sports?.some((element) =>
            filterBySportsCategory?.includes(element)
          );
        });
      setPatientRegionsState(filteredBySportCategoryRegions);
    }
  }, [patientRegions, filterBySportsCategory]);

  const onClick = (sortBy: string) => {
    if (sortBy != "sport") {
      dispatch(changeSortOfPatientRegionsList(sortBy));
      setPatientRegionsState([]);
    }
  };

  const onLoadMore = useCallback(() => {
    dispatch(loadMorePatientRegions());
  }, [dispatch]);

  return currentClinicianLoading ? (
    <CircularProgress color="inherit" size={20} />
  ) : (
    <div className="mt-6 flex flex-col white-space-nowrap pb-16">
      {currentClinician?.role?.includes(USER_GROUPS.COACH) && (
        <ContainerForCoaches
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          coachId={currentClinician._id}
          patientRegionsState={patientRegionsState}
          onClick={onClick}
          sortConfig={sortConfig}
          loading={loading}
          onPageChange={(newPage) => {
            setCurrentPage(newPage);
            const offset = newPage * patientsLimit - 50;

            dispatch(patientRegionsSlice.setOffset(offset));
            dispatch(loadMorePatientRegions());
          }}
          page={currentPage}
          totalPages={Math.ceil(patientsTotal / patientsLimit)}
        />
      )}
      {currentClinician?.role?.includes(USER_GROUPS.CLINICIAN) && (
        <ContainerForClinicians
          patientRegionsState={patientRegionsState}
          onClick={onClick}
          sortConfig={sortConfig}
          loading={loading}
          onLoadMore={onLoadMore}
          hasMoreItems={hasMoreItems}
        />
      )}
    </div>
  );
};
